(function(){
  
  function pathFinder(value, index, arr){
    if(window.location.pathname === value.path){
      mixpanel.track(value.trackTag);
      console.log(value.trackTag);
    }
  }
  
  var pagesArr = [];
  pagesArr.push({ path : '/', trackTag : 'Viewed Homepage'});
  pagesArr.push({ path : '/cart', trackTag : 'Viewed Cart'});
  pagesArr.push({ path : '/pages/about-us', trackTag : 'Viewed About Us'});
  pagesArr.push({ path : '/pages/returns-policy', trackTag : 'Viewed Return Policy'});
  pagesArr.push({ path : '/pages/hat-sizing', trackTag : 'Viewed Sizing Guide Page'});
  pagesArr.push({ path : '/apps/shipping-details', trackTag : 'Viewed Shipping Policy'});
  pagesArr.push({ path : '/pages/contact-us', trackTag : 'Viewed Contact Page'});
  pagesArr.push({ path : '/pages/faq', trackTag : 'Viewed FAQ Page'});
  pagesArr.push({ path : '/pages/hat-etiquette', trackTag : 'Viewed Hat Etiquette Page'});
  pagesArr.push({ path : '/pages/hat-questions', trackTag : 'Viewed Hat Questions Page'});
  pagesArr.push({ path : '/pages/hat-glossary', trackTag : 'Viewed Hat Glossary Page'});
  pagesArr.push({ path : '/account/login', trackTag : 'Viewed Login Page'});
  pagesArr.push({ path : '/account', trackTag : 'Viewed Account Page'});
  pagesArr.push({ path : '/account/register', trackTag : 'Viewed Register Page'});
  pagesArr.push({ path : '/collections', trackTag : 'Viewed Collections Page'});
  pagesArr.push({ path : '/collections/all', trackTag : 'Viewed All Products Page'});
  pagesArr.push({ path : '/collections/bailey-hats', trackTag : 'Viewed Bailey Hats Collection Page'});
  pagesArr.push({ path : '/collections/barbisio', trackTag : 'Viewed Barbisio Collection Page'});
  pagesArr.push({ path : '/collections/biltmore', trackTag : 'Viewed Biltmore Collection Page'});
   pagesArr.push({ path : '/collections/broner-hats', trackTag : 'Viewed Broner Hats Collection Page'});
   pagesArr.push({ path : '/collections/country-gentlemen', trackTag : 'Viewed Country Gentlemen Collection Page'});
   pagesArr.push({ path : '/collections/dobbs-hats', trackTag : 'Viewed Dobbs Hats Collection Page'});
   pagesArr.push({ path : '/collections/henschel-hats', trackTag : 'Viewed Henschel Hats Collection Page'});
   pagesArr.push({ path : '/collections/kangol-hats', trackTag : 'Viewed Kangol Hats Collection Page'});
   pagesArr.push({ path : '/collections/mayser-hats', trackTag : 'Viewed Mayser Hats Collection Page'});
   pagesArr.push({ path : '/collections/scala-hats', trackTag : 'Viewed Scala Hats Collection Page'});
   pagesArr.push({ path : '/collections/selentino', trackTag : 'Viewed Selentino Collection Page'});
   pagesArr.push({ path : '/collections/stacy-adams', trackTag : 'Viewed Stacy Adams Collection Page'});
   pagesArr.push({ path : '/collections/stefeno', trackTag : 'Viewed Stefeno Collection Page'});
   pagesArr.push({ path : '/collections/stetson-hats', trackTag : 'Viewed Stetson Hats Collection Page'});
   pagesArr.push({ path : '/collections/tilley-hats', trackTag : 'Viewed Tilley Hats Collection Page'});
   pagesArr.push({ path : '/collections/fedoras', trackTag : 'Viewed Fedoras Collection Page'});
   pagesArr.push({ path : '/collections/homburg-godfather', trackTag : 'Viewed Homburg Godfather Collection Page'});
   pagesArr.push({ path : '/collections/derby-top-hat', trackTag : 'Viewed Derby Top Hats Collection Page'});
   pagesArr.push({ path : '/collections/ivy-newsboy-caps', trackTag : 'Viewed Ivy Newsboy Caps Collection Page'});
   pagesArr.push({ path : '/collections/baseball-cap', trackTag : 'Viewed Baseball Cap Collection Page'});
   pagesArr.push({ path : '/collections/bucket', trackTag : 'Viewed Bucket Collection Page'});
   pagesArr.push({ path : '/collections/army-cap', trackTag : 'Viewed Army Cap Collection Page'});
   pagesArr.push({ path : '/collections/knit', trackTag : 'Viewed Knit Collection Page'});
   pagesArr.push({ path : '/collections/western-outback', trackTag : 'Viewed Western Outback Collection Page'});
   pagesArr.push({ path : '/collections/xxl', trackTag : 'Viewed XXL Collection Page'});
   pagesArr.push({ path : '/collections/rain-hats', trackTag : 'Viewed Rain Hats Collection Page'});
   pagesArr.push({ path : '/collections/straw-panama', trackTag : 'Viewed Straw Panama Collection Page'});
   pagesArr.push({ path : '/collections/spring-summer-hats', trackTag : 'Viewed Spring Summer Hats Collection Page'});
   pagesArr.push({ path : '/collections/fall-winter-hats', trackTag : 'Viewed Fall Winter Hats Collection Page'});
   pagesArr.push({ path : '/collections/accessories', trackTag : 'Viewed Accessories Collection Page'});
   pagesArr.push({ path : '/collections/shoes', trackTag : 'Viewed Shoes Collection Page'});
   pagesArr.push({ path : '/collections/mezlan', trackTag : 'Viewed Mezlan Collection Page'});
   pagesArr.push({ path : '/collections/bacco-bucci', trackTag : 'Viewed Bacco Bucci Collection Page'});
   pagesArr.push({ path : '/collections/belvedere', trackTag : 'Viewed Belvedere Collection Page'});
   pagesArr.push({ path : '/collections/stacy-adams-shoes', trackTag : 'Viewed Stacy Adams Shoes Collection Page'});
   pagesArr.push({ path : '/collections/steven-land-shoes', trackTag : 'Viewed Steven Land Shoes Collection Page'});
   pagesArr.push({ path : '/collections/boots', trackTag : 'Viewed Boots Collection Page'});
   pagesArr.push({ path : '/collections/dress', trackTag : 'Viewed Dress Collection Page'});
   pagesArr.push({ path : '/collections/causual', trackTag : 'Viewed Casual Collection Page'});
   pagesArr.push({ path : '/collections/sneakers', trackTag : 'Viewed Sneakers Collection Page'});
   pagesArr.push({ path : '/collections/exotic-skin', trackTag : 'Viewed Exotic Skin Collection Page'});
   pagesArr.push({ path : '/collections/sale', trackTag : 'Viewed Sale Collection Page'});
   pagesArr.push({ path : '/collections/the-last-straw', trackTag : 'Viewed The Last Straw Collection Page'});
   pagesArr.push({ path : '/collections/fur-felt-hats', trackTag : 'Viewed Fur Felt Hats Collection Page'});
  pagesArr.push({ path : '/pages/brands', trackTag : 'Viewed Brands Page'});

  
  pagesArr.forEach(pathFinder);
  
  if($('body').hasClass('template-collection')) {
   mixpanel.track('Viewed Collection');
  }
  
  $('.mobile-navigation-toggle').click(function(){
    mixpanel.track('Clicked Mobile Menu');
  });
  
    $('.mobie-header-search-toggle').click(function(){
    mixpanel.track('Clicked Mobile Search Button');
  });
 
  
  $('.social-networks a').click(function(e){
    var $this = $(this);
    var socialNetwork = $(this).parent()[0].classList[1];
    console.log(socialNetwork);
    mixpanel.track('Clicked on Social Footer Icon', {
      "Social Network Type" : socialNetwork
    });
  });
  
  //check if newsletter was submitted and track it in mixpanel
  $('.newsletter-submit').click(function(e){
    if ( $('.newsletter-email').val().includes('.com') && $('.newsletter-email').val().includes('@')){
    	mixpanel.track('Submitted Footer Newsletter', {
      "e-mail" : $('.newsletter-email').val()
    });
    }
  });
})();